import { render } from "./HeadlineChangeRow.vue?vue&type=template&id=ef94091a&scoped=true"
import script from "./HeadlineChangeRow.vue?vue&type=script&lang=js"
export * from "./HeadlineChangeRow.vue?vue&type=script&lang=js"

import "./HeadlineChangeRow.vue?vue&type=style&index=0&id=ef94091a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef94091a"]])

export default __exports__